export const FilterDesktop = ({ filtersList }) => {
  return (
    <aside className="search-filters min-w-[200px] max-w-[200px] hidden lg:grid lg:mr-7">
      <div className="flex flex-col">
        <span className="font-medium text-gray-dark">
          Filtrar pesquisa por:
        </span>
        <ul className="gap-y-6 grid">{filtersList}</ul>
      </div>
    </aside>
  );
};
